module.exports = __webpack_public_path__ + "static/media/WebRTC_needs_servers.18a98a74.png";